import { render } from "./AgentList.vue?vue&type=template&id=225d13fa&scoped=true"
import script from "./AgentList.vue?vue&type=script&lang=js"
export * from "./AgentList.vue?vue&type=script&lang=js"

import "./AgentList.vue?vue&type=style&index=0&id=225d13fa&lang=less&scoped=true"

import exportComponent from "G:\\小程序\\OT ASAR\\vue后台\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225d13fa"]])

export default __exports__